<ng-container *appIfIsDesktop>
  <input
    appSearchInputDropdownWidth
    #searchCityInputDesktop
    [ngbTypeahead]="searchCity"
    [placement]="'bottom-left'"
    [popupClass]="'search-location-popup search-location-popup-desktop search-location-popup-desktop-city'"
    [focusFirst]="false"
    [editable]="false"
    [inputFormatter]="googleMapsService.formatter"
    [resultFormatter]="googleMapsService.formatter"
    [ngClass]="inputClass"
    type="text"
    class="form-control form-control-input input-placeholder input-placeholder-hidden"
    id="search-input"
    [placeholder]="mainInputHover ? '      City or Address': ''"
    (selectItem)="selectItem($event)"
    (input)="onCityInputDesktop($event)"
    (click)="onFocusInput()"
    (blur)="onInputBlur()"
  >
</ng-container>

<div *appIfIsMobile class="mobile-icons">
  <i *ngIf="!searchCityInput.value" class="icon-v2 search-white" (click)="iconClicked()"></i>

  <input
    #searchCityInput
    [ngbTypeahead]="searchCityMobile"
    [placement]="'bottom-left'"
    [popupClass]="'search-city-popup search-city-popup-mobile'"
    [focusFirst]="false"
    [editable]="false"
    [inputFormatter]="googleMapsService.formatter"
    [resultFormatter]="googleMapsService.formatter"
    [ngClass]="inputClass"
    type="text"
    class="form-control text-white input-placeholder input-placeholder-mobile"
    placeholder="        City or Address"
    autocomplete="new-search-city"
    (selectItem)="selectItemMobile($event)"
    (focus)="onFocusInput()"
    (blur)="onInputBlur()"
  >

  <div
    *ngIf="clearIcon && searchCityInput.value"
    class="search-city-find-me pr-1-75rem safe-area-top pointer-events-all"
  >
    <i class="icon-v2 close-circle-dark" (click)="clearInput()"></i>
  </div>

  <div
    *ngIf="!(clearIcon && searchCityInput.value)"
    class="search-city-find-me pr-1-75rem safe-area-top"
  >
    <a appHrefNone class="text-white" (click)="onFindMe()">Find me</a>
  </div>
</div>
